import PeopleOutlinedIcon from "@material-ui/icons/PeopleOutlined";
import { DriversListView } from "./DriversListView";

export default {
  list: DriversListView,
  icon: PeopleOutlinedIcon,
};

export type DriverStatus = "active" | "inactive";
export type DriverDutyStatus =
  | "offDuty"
  | "personalDriving"
  | "sleeperBerth"
  | "driving"
  | "onDutyNotDriving"
  | "yardMove";

export interface IHosDriverView {
  driverId: number; // Driver PK
  driverDisplayName: string;
  driverStatus: DriverStatus; // active, inactive
  driverDutyStatus: DriverDutyStatus; // offDuty, personalDriving, sleeperBerth, driving, onDutyNotDriving, yardMove
  driverDutyStatusDuration: number; // minutes
  driverPhoneNumber: string;
  vehicleId: number; // Vehicle PK
  vehicleNumber: string;
  trailerNumber: string;
  timeUntilBreak: number; // minutes
  timeToDrive: number; // minutes
  shiftTimeLeft: number; // minutes
  cycleTimeLeft: number; // minutes
  lastActivity: number; // epoch milliseconds
  lastPositionName: string;
  lastPositionLat: number;
  lastPositionLong: number;
  violations: boolean;
}
